import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InvestmentGeographicAllocationModel } from '../../Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel';
import { IJsonDate } from '../../System/IJsonDate';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentGeographicAllocationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, asAt: IJsonDate, assetClassType: AssetClassType): Promise<Array<InvestmentGeographicAllocationModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transformation/InvestmentGeographicAllocation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, asAt: asAt, assetClassType: assetClassType }

    return AjaxWrapper.get<Array<InvestmentGeographicAllocationModel>, any>(url, data);
  }
}

